//API serivice FUNCTIONS
import moment from "moment";
import { success } from "../../Components/Helpers/notification";
import { catchAsyncErrors, filterByChoice, getFromLocalStorage, setToLocalStorage, timeFormatter } from "../../Helpers/helpers";
import { error } from "../../Helpers/notification";
import roles from "../../Helpers/roles";
import AuthService from '../../Utils/AuthProvider'
import { changeDowntimeDate, changeLineRange, setDisconnectLogs, setDowntimeLogs, setLogs } from "../../Redux/features/logs.slice";
import { setCurrentPlant, setPlantsList } from "../../Redux/features/plant.slice";
import { setComponentLoader, setPageLoader, setPageReloader } from "../../Redux/features/utils.slice";
import { getRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
const { logs, forceStop,kpis } = apiRoutes;

const getAllLogs = async (dispatch, current, downtimeDate, page = 'downtimeLogs') => {

    //Setting Page Loader = True
    dispatch(setPageLoader({ page, flag: true }))

    // Setting up Dates for API
    let { plant = null, line = null, machine = null } = current;
    const tomorrow = moment(downtimeDate).add(1, 'days');
   
    let start = `${moment(downtimeDate, 'YYYY-MM-DD HH:mm').toISOString()}`
    
    let end = `${moment(tomorrow, 'YYYY-MM-DD HH:mm').toISOString()}`

    // API Hits ( Downtime and Disconnect Logs )

    let downtimeRes = null;
    let disconnectRes = null;
    const machineName = machine?.machineName == 'default' ? null : machine?.machineName;
    
     disconnectRes = await postRequest({
        endPoint: logs.disconnect,
        body: { "conditions": {"started": {"$gte": start, "$lte": end}, "plantId": plant?._id, "lineId": line?.id, "machine": machineName, "attributes": undefined}}
        //   `{%22started%22:{%22$gte%22:%22${start}%22,%22$lte%22:%22${end}%22},%22plantId%22:%22${plant?._id}%22,%22lineId%22:%22${line?.id}%22,%22machine%22:${machineName !== 'default' ? `%22${machineName}%22` : null}}&attributes=undefined`
    })
    downtimeRes = await postRequest({
        endPoint: logs.downtimes,
        body: { "conditions": {"started": {"$gte": start, "$lte": end}, "plantId": plant?._id, "lineId": line?.id, "machine": machineName, "attributes": undefined}}
        //   `{%22started%22:{%22$gte%22:%22${start}%22,%22$lte%22:%22${end}%22},%22plantId%22:%22${plant?._id}%22,%22lineId%22:%22${line?.id}%22,%22machine%22:${machineName !== 'default' ? `%22${machineName}%22` : null}}&attributes=undefined`
      });
    let disconnect = []
    let downtimes = []
    if (disconnectRes?.response?.length)
        disconnect = disconnectRes?.response
            ?.map((disconnect, index) => {
                let { hours, seconds, minutes } = moment.duration(new moment(disconnect?.ended || new Date()).diff(new moment(disconnect?.started)))._data
                let duration = timeFormatter(hours) + ':' + timeFormatter(minutes) + ':' + timeFormatter(seconds)
                return {
                    ...disconnect,
                    key: disconnect._id,
                    startedAt: disconnect?.started,
                    started: moment(disconnect?.started).format('hh:mm A'),
                    duration: disconnect?.ended ? duration : 'Still Running',
                    reason: disconnect?.reason || null,
                    comment: disconnect?.comment || 'N/A',
                    type: disconnect.ended ? 'disconnectLog' : 'disconnectLog'
                }
            })

    if (downtimeRes?.response?.length)
        downtimes = downtimeRes?.response
            ?.map((downtime, index) => {
                let { hours, seconds, minutes } = moment.duration(new moment(downtime?.ended || new Date()).diff(new moment(downtime?.started)))._data
                let duration = timeFormatter(hours) + ':' + timeFormatter(minutes) + ':' + timeFormatter(seconds)
                return {
                    ...downtime,
                    key: downtime._id,
                    startedAt: downtime?.started,
                    started: moment(downtime?.started).format('hh:mm A'),
                    duration: downtime?.ended ? duration : 'Still Running',
                    reason: downtime?.reason || null,
                    comment: downtime?.comment || 'N/A',
                    type: downtime.ended ? 'downtimeLog' : 'downtimeLog'
                }
            })
    dispatch(setLogs({ disconnect, downtimes }))
    dispatch(setPageLoader({ page, flag: false }))
}

const getDowntimeLogs = async (dispatch, current, lineOpRange, page = 'downtimeLogs') => {

    //Setting Page Loader = True
    dispatch(setPageLoader({ page, flag: true }))
    let { start, end } = lineOpRange;

    // Setting up Dates for API
    let { plant = null, line = null, machine = null } = current;
    end = `${moment(end).format('YYYY-MM-DD')}T01:59:00.000Z`
    start = `${moment(start).format('YYYY-MM-DD')}T20:00:00.000Z`

    // API Hits ( Downtime Logs )
    let downtimeRes = null;
    const machineName = machine?.machineName == 'default' ? null : machine?.machineName;
    
    downtimeRes = await postRequest({
        endPoint: logs.downtimes,
        body: { "conditions": {"started": {"$gte": start, "$lte": end}, "plantId": plant?._id, "lineId": line?.id, "machine": machineName, "attributes": undefined}}
        // `{%22started%22:{%22$gte%22:%22${start}%22,%22$lte%22:%22${end}%22},%22plantId%22:%22${plant?._id}%22,%22lineId%22:%22${line?.id}%22,%22machine%22:${machineName !== 'default' ? `%22${machineName}%22` : null}}&attributes=undefined`
    });
    
    let downtimes = []
    if (downtimeRes?.response?.length) {
        downtimes = downtimeRes?.response
            ?.map((downtime, index) => {
                let { hours, seconds, minutes } = moment.duration(new moment(downtime?.ended || new Date()).diff(new moment(downtime?.started)))._data
                let duration = timeFormatter(hours) + ':' + timeFormatter(minutes) + ':' + timeFormatter(seconds)
                return {
                    ...downtime,
                    key: index + 1,
                    startedAt: downtime?.started,
                    started: moment(downtime?.started).format('hh:mm A'),
                    duration: downtime?.ended ? duration : 'Still Running',
                    reason: downtime?.reason || null,
                    comment: downtime?.comment || 'N/A',
                    type: downtime.ended ? 'downtimeLog' : 'downtimeLog'
                }
            })
    }
    dispatch(setDowntimeLogs({ downtimes }))
    dispatch(setPageLoader({ page, flag: false }))
}

const onDowntimeDateChange = async (date, inString, dispatch, current) => {
    dispatch(changeDowntimeDate({
        selectedDate: inString
    }))
}

const updateDowntime = async (...params) => {
    let [body, dispatch, current] = params
    let { comment, reason = '', record, categories = ['custom'], page = 'downtimeLogs' } = body;
    dispatch(setPageLoader({ page, flag: true }))
    let user = await getFromLocalStorage('user')
    let data = filterByChoice(current?.plant?.accessControl, 'email', user?.username)


    let currentUser = data.length ? data : roles['superAdmin']
    let apiBody = {
        _id: record?._id,
        categories: record?.categories || categories,
        lineId: record?.lineId,
        plantId: current?.plant?._id,
        comment: comment,
        reason: reason,
        history: record?.history ?
            [
                ...record?.history,
                {
                    authority: currentUser?.role,
                    reason: reason,
                    comment: comment,
                    categories: record?.categories,
                    userEmail: user?.username,
                    createdAt: moment(new Date()).format('YYYY-MM-DDThh:mm:ss'),
                    action: "Updated"
                }
            ] :
            [{
                authority: currentUser?.role,
                reason: reason,
                comment: comment,
                categories: record?.categories,
                userEmail: user?.username,
                createdAt: moment(new Date()).format('YYYY-MM-DDThh:mm:ss'),
                action: "Updated"
            }],
    }
    let essentials = {
        endPoint: (record?.type == 'disconnectTime' || record?.type == 'disconnectTimeEnded')
            ? logs.updateDisconnect : logs.updateDowntime,
        body: apiBody
    }
    // console.log({ essentials })
    let res = await postRequest(essentials)
    if (!res.success) {
        dispatch(setPageLoader({ page: 'downtimeLogs', flag: false }))
        error(res.response)
        return
    }
    success('Updated Downtime.')
    const time = moment(record.ended || record.started).toDate();
    let bodyData = {
        productionLineId:record?.lineId,
        time,
        machine: record.machine ? record.machine : null,
        statsGenerate:true,
    }
    let response = await postRequest({
        endPoint: kpis.generateStats,
        body:bodyData
    })
    if(!response.success)
    {
        dispatch(setPageLoader({ page: 'downtimeLogs', flag: false }))
        error(res.response)
        return
    }
    success('OEE Adjusted');
    dispatch(setPageReloader({ page }))
    dispatch(setPageLoader({ page, flag: false }))
}

const updateLineRange = async (date, inString, dispatch) => {
    let range = { start: inString[0], end: inString[1] }
    dispatch(changeLineRange(range))
}

const mergeDowntimes = async (payload, dispatch, current) => {
    // console.log({ payload })
    dispatch(setComponentLoader({ component: 'merge', flag: true }))
    let body = {
        downtime: {
            reason: "",
            started: payload[0]?.startedAt,
            ended: payload[1]?.ended,
            lineId: current?.line?.id,
            machine: current?.machine?.machineName
        }
    }
    let essentials = {
        endPoint: `${logs.mergeDowntime}lineId=${current?.line?.id}&plantId=${current?.plant?._id}&id=[%22${payload[0]?._id}%22,%22${payload[1]?._id}%22]`,
        body
    };
    let response = await postRequest(essentials)
    // console.log({ response, essentials })
    dispatch(setComponentLoader({ component: 'merge', flag: false }))
    dispatch(setPageReloader({ page: 'downtimes' }))
}

const splitDowntimes = async (payload, dispatch, current) => {
    // console.log({ payload })
console.log(payload);

    dispatch(setComponentLoader({ component: 'split', flag: true }))
    let body = {
        downtimeBefore: {
            started: payload?.startedAt,
            ended: `${moment(payload?.startedAt).format('YYYY-MM-DD')}T${payload?.splitTime}.000Z`,
            reason: payload?.reason || "",
            machine: current?.machine?.machineName,
            lineId: current?.line?.id
        },
        downtimeAfter: {
            started: `${moment(payload?.startedAt).format('YYYY-MM-DD')}T${payload?.splitTime}.000Z`,
            ended: payload?.ended,
            reason: payload?.reason || "",
            machine: current?.machine?.machineName,
            lineId: current?.line?.id
        }
    }
    let essentials = {
        endPoint: `${logs.splitDowntime}lineId=${current?.line?.id}&plantId=${current?.plant?._id}&id=[%22${payload?._id}%22]`,
        body
    };
    // console.log({ essentials })
    let response = await postRequest(essentials)
    // console.log({ response, essentials })
    dispatch(setComponentLoader({ component: 'split', flag: false }))
    dispatch(setPageReloader({ page: 'downtimes' }))
}

const forceStopShift = async (dispatch, current,selectedMachines=[]) => {

    let { plant = null, machine = null, shift = null, line = null } = current;
    const currentTime = new Date();
    //console.log(currentTime,'curentTime');
    //let x = new Date()
    //console.log(x,'new Date()');
    let defaultMachine = machine && machine.machineName == 'default';
    let data = {};

    if(selectedMachines.length>0)
    {
        selectedMachines.map(x => {
            if (x == 'default') {
              data.status = {
                status: 'shift ended',
              time: new Date(),
            }
            }
            else {
              data[`${x} status`] = {
                status: 'shift ended',
                time: new Date(),
              }
              // let machine = productionLine.machines.find(y => y.machineName == x)
              // machine.status = {
              //   status: 'shift ended',
              //   time: new Date(),
              // }
          }
        })
    }
    if(!defaultMachine){
        data[`${machine.machineName} status`] = {
            status: 'shift ended',
            time: new Date(),
          }
    }
    else if(defaultMachine){
        data.status = {
              status: 'shift ended',
              time: new Date(),
            }
          
    }
    let payloads = {
        first: {
            endPoint: forceStop.email,
            body: {
                currentShiftName: current?.shift?.name,
                machine: defaultMachine?null:current?.machine?.machineName,
                productionLineId: current?.line?.id
            }
        },
        second: {
            endPoint: forceStop.updateLine,
            body: {
                plantId: current?.plant?._id,
                ...data,
                updateAt: currentTime,
                _id: current?.line?.id
            }
        },
        third: {
            endPoint: forceStop.updateStats,
            body: {
                lineId: line?.id,
                plantId: plant?._id,
                status: 'shift ended',
                updatedAt: currentTime,
                updated_at: currentTime,
                _id: (machine && machine.machineName !== 'default')?`${line?.id}-${machine?.machineName}-${shift?.range}-${moment(new Date()).format('YYYY-MM-DD')}`:`${line?.id}-${shift?.range}-${moment(new Date()).format('YYYY-MM-DD')}`
            }
        },
        fourth: {
            endPoint: forceStop.createLog,
            body: {
                action: "Shift Force Stopped",
                email: getFromLocalStorage('user')?.username,
                hallName: current?.hall?.hallName,
                lineId: line?.id,
                lineName: line?.lineName,
                machine: machine?.displayName,
                plantName: plant?.plantName,
                plantId: plant?._id,
                shiftName: shift?.name,
                time: currentTime,
                userId: 'test132',
                detailsBefore: {
                    StoppedShift: shift?.name
                }
            }
        }
    }

    let emailOnStop = await postRequest(payloads.first)
    let productionLine = await postRequest(payloads?.second)
    let stats = await postRequest(payloads?.third)
    let logs = await postRequest(payloads?.fourth)

    console.log({ emailOnStop, productionLine, stats, logs })
}

const changeProduct = async (shifts, currentShift, selectedProduct, obj, line, detailsAfter, dispatch, log, machine, plantId) => {
    console.log('here.......')
    console.log(shifts, 'shifts', currentShift, 'currentS', selectedProduct, 'selectedP', obj, 'obj', line, 'line', detailsAfter, 'detailsA', log, 'log', machine, 'machine', plantId, 'plant id')
//     let data = {}
//   if (machine) {
//      line.machines.map(x => {
//       if (x.machineName == machine.machineName){
//         x.shifts = shifts
//       }
//     })
//     data = {
//       'machines': line.machines
//     }
//   }
//   else {
//     data = {
//       shifts
//     }
//   }
//   if (obj.product.id != selectedProduct.id) {
//     let productLog = {
//       lineId: line.id,
//       time: new Date(),
//       plantId,
//       detailsAfter,
//       detailsBefore: obj
//     };

// }
}

const sendResetPasswordEmail = async(email) => {
    await AuthService.fetchForgotPassword(email)
}
const confirmPasswordAndCode = async (email, code, password) => {
    await AuthService.fetchConfirmPassword(email, code, password)
  }


export {
    getAllLogs,
    onDowntimeDateChange,
    updateDowntime,
    getDowntimeLogs,
    updateLineRange,
    mergeDowntimes,
    splitDowntimes,
    forceStopShift,
    sendResetPasswordEmail,
    confirmPasswordAndCode,
    changeProduct
}